import styled from 'styled-components';
import { Button as AntdButton } from 'antd';

export const LeverageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const Chip = styled(AntdButton)`
  border-radius: 15px;
  font-size: 12px;
  fonwt-weight: 400;
  line-height: 16px;
  padding: 6px 12px;
  text-align: center;
  color: #858585;
  background: #ffffff;
  border: 1px solid #ededed;
  cursor: pointer;

`;

interface INoneButtonProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const NoneButton = styled(Chip)<INoneButtonProps>`
  &:hover,
  &:focus,
  &:active {
    color: #858585;
    border: 1px solid #ededed;
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: #0ba16b;
    font-weight: 700;
    border-color: #0ba16b;

    &:hover, &:focus, &:active {
      color: #0ba16b;
      border-color: #0ba16b;
    }
  `}

  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: #858585;
    font-weight: 400;
    border-color: #EDEDED;
    cursor: not-allowed;

    &:hover, &:focus, &:active {
      color: #858585;
      border-color: #EDEDED;
    }
  `}
`;

export const ActionButton = styled(NoneButton)`
  min-width: min-content;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  padding: 6px 16px 6px 14px;

  span {
    margin: 0 !important;
  }
`;
